/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.221.0-v202611021934-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqItemsApiClass {
 
   constructor() {}

  /**
   * @summary Add an access control entry to an item
   * @param {string} id - ID of the item to add access control entry to
  */
  public addAccessControlEntry(
    body: models.AceInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/${encodeURIComponent(String(id))}/ace`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/items/{id}/ace`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.AclOutputV1>;
  }

  /**
   * @summary Archive or delete an item
   * @param {string} id - ID of the item for which to retrieve properties
   * @param {boolean} [_delete=false] - Permanently and irretrievably delete the item
   * @param {string} [archivedReason=BY_USER] - The reason for archiving the item. Can be one of OBSOLETE_SQLV1, BY_USER, DATASOURCE_CLEANUP, BY_MIGRATION, BY_PARENT_ITEM, BY_AUTO_ARCHIVE, BY_SANDBOX_MODE, or NONE
   * @param {string} [note] - An optional note for why the item was archived
  */
  public archiveItem(
    {
      id,
      _delete,
      archivedReason,
      note
    } : {
      id: string,
      _delete?: boolean,
      archivedReason?: string,
      note?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/items/{id}`;

    const queryParams = {
      ['delete']: _delete,      ['archivedReason']: archivedReason,      ['note']: note
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Archive an item finder
   * @param {string} id - ID of the item finder to archive.
  */
  public archiveItemFinder(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/finders/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/items/finders/{id}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.ArchiveOutputV1>;
  }

  /**
   * @summary Build table definition column inputs from stored table searches
  */
  public buildStoredTableColumnDefinitions(
    body: models.StoredTableColumnDefinitionsInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/finders/stored-table-column-definitions`;
    const urlTemplate = `${baseUrl}/items/finders/stored-table-column-definitions`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.StoredTableColumnDefinitionsOutputV1>;
  }

  /**
   * @summary Change the owner of the specified item to the specified user. You need to have the analytics administrator capability to change the owner.
   * @param {string} itemId - ID of the item to change owner for
   * @param {string} newOwnerId - ID of the user to become the new owner
  */
  public changeOwner(
    {
      itemId,
      newOwnerId
    } : {
      itemId: string,
      newOwnerId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (itemId === null || itemId === undefined) {
      throw new Error("'itemId' parameter required");
    }

    if (newOwnerId === null || newOwnerId === undefined) {
      throw new Error("'newOwnerId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/${encodeURIComponent(String(itemId))}/owner/${encodeURIComponent(String(newOwnerId))}`
      .replace('{itemId}', encodeURIComponent(String(itemId)))
      .replace('{newOwnerId}', encodeURIComponent(String(newOwnerId)));
    const urlTemplate = `${baseUrl}/items/{itemId}/owner/{newOwnerId}`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Clear the cache for an item.
   * @param {string} id - ID of the item on which to clear cache
   * @param {boolean} [clearDependents=true] - Whether dependent caches should be cleared. Should always be true if a cache is in error, but false may be valuable when merely trying to recover disk space.
  */
  public clearCache(
    {
      id,
      clearDependents
    } : {
      id: string,
      clearDependents?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/${encodeURIComponent(String(id))}/cache`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/items/{id}/cache`;

    const queryParams = {
      ['clearDependents']: clearDependents
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.CacheInfoV1>;
  }

  /**
   * @summary Count the items matched by each include search without returning any items. Counts are reported per include search and are not deduplicated across searches, and exclude searches are not applied, so a count is an upper bound on how many items a search contributes to a finder's output. This endpoint is experimental and may change in future releases.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public countItemFinderSearches(
    body: models.ItemFinderSearchCountInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/finders/search/count`;
    const urlTemplate = `${baseUrl}/items/finders/search/count`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ItemFinderSearchCountOutputV1>;
  }

  /**
   * @summary Create a context condition on a specified item. If one already exists, it will be returned
   * @param {string} id - The id of the source item
  */
  public createContextCondition(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/${encodeURIComponent(String(id))}/context`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/items/{id}/context`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.ConditionOutputV1>;
  }

  /**
   * @summary Create a new item finder
  */
  public createItemFinder(
    body: models.ItemFinderInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/finders`;
    const urlTemplate = `${baseUrl}/items/finders`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ItemFinderOutputV1>;
  }

  /**
   * @summary Delete a property
   * @param {string} id - ID of the item whose property is being deleted
   * @param {string} propertyName - Name of the property to delete
  */
  public deleteProperty(
    {
      id,
      propertyName
    } : {
      id: string,
      propertyName: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }

    if (propertyName === null || propertyName === undefined) {
      throw new Error("'propertyName' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/${encodeURIComponent(String(id))}/properties/${encodeURIComponent(String(propertyName))}`
      .replace('{id}', encodeURIComponent(String(id)))
      .replace('{propertyName}', encodeURIComponent(String(propertyName)));
    const urlTemplate = `${baseUrl}/items/{id}/properties/{propertyName}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Triggers an immediate execution of the Item Finder job.
   * @param {string} id - ID of the item finder to execute.
  */
  public executeItemFinder(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/finders/${encodeURIComponent(String(id))}/run`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/items/finders/{id}/run`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.ItemFinderOutputV1>;
  }

  /**
   * @summary Execute item finder searches. This method is deprecated.
   * @deprecated Deprecated in favor of POST /v2/search, which has more functionality.
  */
  public executeItemFinderSearches(
    body: models.ItemFinderSearchesInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/finders/search`;
    const urlTemplate = `${baseUrl}/items/finders/search`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ItemFinderSearchesOutputV1>;
  }

  /**
   * @summary Execute item finder searches, optionally returning requested item properties inline. This endpoint is experimental and may change in future releases.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public executeItemFinderSearchesV2(
    body: models.ItemFinderSearchesInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/finders/v2/search`;
    const urlTemplate = `${baseUrl}/items/finders/v2/search`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ItemFinderSearchesOutputV2>;
  }

  /**
   * @summary Create, or find, a variant of the item that is based on the specified asset. For example, given the ID for Temperature in Area A, find its equivalent for Area B. Or, for a formula that uses Area A Temperature as an input, create a variant that that is based off Area B.
   * @param {string} id - ID of the item that is being updated
  */
  public findSwap(
    body: Array<models.SwapInputV1>,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/${encodeURIComponent(String(id))}/swap`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/items/{id}/swap`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ItemPreviewV1>;
  }

  /**
   * @summary Get the current access control list for an item
   * @param {string} id - ID of the item to get access control list for
  */
  public getAccessControl(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/${encodeURIComponent(String(id))}/acl`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/items/{id}/acl`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.AclOutputV1>;
  }

  /**
   * @summary Get the current access control list for an item with details of inherited entries
   * @param {string} id - ID of the item to get access control list for
   * @param {boolean} [forceAclInheritance=false] - Show the ACL details as if access control inheritance would be enabled for the item
  */
  public getAccessControlDetails(
    {
      id,
      forceAclInheritance
    } : {
      id: string,
      forceAclInheritance?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/${encodeURIComponent(String(id))}/acl/details`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/items/{id}/acl/details`;

    const queryParams = {
      ['forceAclInheritance']: forceAclInheritance
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.AclOutputV1>;
  }

  /**
   * @summary Get the leaf descendants of an asset grouped by name, with a count per name
   * @param {string} asset - The ID of the asset whose leaf descendants should be grouped and counted.
   * @param {Array<string>} types - A list of one or more case-sensitive item types (typically Signal, Condition, Scalar, ThresholdMetric) to restrict results to. Subtypes are included. At least one type must be provided.
   * @param {string} [filter] - An optional case-insensitive substring used to filter the returned names.
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results. When using limit or offset values to query different item subsets it is important to sort the results using orderBy. Otherwise inconsistent results may be returned.
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results. When using limit or offset values to query different item subsets it is important to sort the results using orderBy. Otherwise inconsistent results may be returned.
  */
  public getAssetChildrenByName(
    {
      asset,
      types,
      filter,
      offset,
      limit
    } : {
      asset: string,
      types: Array<string>,
      filter?: string,
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (asset === null || asset === undefined) {
      throw new Error("'asset' parameter required");
    }

    if (types === null || types === undefined) {
      throw new Error("'types' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/asset-children-by-name`;
    const urlTemplate = `${baseUrl}/items/asset-children-by-name`;

    const queryParams = {
      ['asset']: asset,      ['types']: types,      ['filter']: filter,      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.AssetChildrenByNamePaginatedListV1>;
  }

  /**
   * @summary Returns the context condition attached to the specified item
   * @param {string} id - The id of the source item
  */
  public getContextCondition(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/${encodeURIComponent(String(id))}/context`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/items/{id}/context`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.ConditionOutputV1>;
  }

  /**
   * @summary Get the formula dependencies of an Item.
   * @param {string} id - ID of the item to find dependencies of
  */
  public getFormulaDependencies(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/${encodeURIComponent(String(id))}/dependencies`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/items/{id}/dependencies`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.ItemDependencyOutputV1>;
  }

  /**
   * @summary Get a collection of items dependent on the item identified by the supplied ID.
   * @param {string} id - ID of the item to find dependents of
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results
  */
  public getFormulaDependents(
    {
      id,
      offset,
      limit
    } : {
      id: string,
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/${encodeURIComponent(String(id))}/dependents`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/items/{id}/dependents`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ItemPreviewListV1>;
  }

  /**
   * @summary Get a collection of items interested in the item identified by the supplied ID.
   * @param {string} id - ID of the item to find all other items interested in the parameter
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results
  */
  public getInterested(
    {
      id,
      offset,
      limit
    } : {
      id: string,
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/${encodeURIComponent(String(id))}/interested`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/items/{id}/interested`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ItemPreviewListV1>;
  }

  /**
   * @summary Get all the properties for the item identified by the supplied ID
   * @param {string} id - ID of the item for which to retrieve properties
  */
  public getItemAndAllProperties(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/items/{id}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.ItemOutputV1>;
  }

  /**
   * @summary Get an item finder
   * @param {string} id - The Seeq ID for the item finder
  */
  public getItemFinder(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/finders/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/items/finders/{id}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.ItemFinderOutputV1>;
  }

  /**
   * @summary Get a list of item finders
   * @param {number} [offset=0]
   * @param {number} [limit=40] - The pagination limit, the total number of item finders that will be returned in this page of results
  */
  public getItemFinders(
    {
      offset,
      limit
    } : {
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/finders`;
    const urlTemplate = `${baseUrl}/items/finders`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ItemFinderOutputListV1>;
  }

  /**
   * @summary Get the ancestors, properties and formula parameters (if applicable) for the item identified by the supplied ID
   * @param {string} id - ID of the item to retrieve
   * @param {Array<string>} [includeProperties] - A list of one or more case-sensitive item properties to include. If omitted, all item properties will be returned. Specified properties not present for an item are simply omitted and do not cause errors.
  */
  public getItemPreview(
    {
      id,
      includeProperties
    } : {
      id: string,
      includeProperties?: Array<string>
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/${encodeURIComponent(String(id))}/preview`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/items/{id}/preview`;

    const queryParams = {
      ['includeProperties']: includeProperties
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ItemSearchPreviewV1>;
  }

  /**
   * @summary Finds all Threshold Metrics and Formulas that are directly built off the specified item.
   * @param {string} id - ID of the item to find usages
   * @param {Array<string>} [scope] - IDs that limit the results to those which are in the global scope or are scoped to the items referenced by the IDs. &lt;br&gt;The following item types can act as a scope: &lt;b&gt;Workbook&lt;/b&gt;&lt;br&gt;If the scope is set to the Empty GUID then the scoped items are excluded
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page
   * @param {number} [limit=500] - The pagination limit, the total number of collection items that will be returned in this page
  */
  public getItemUsages(
    {
      id,
      scope,
      offset,
      limit
    } : {
      id: string,
      scope?: Array<string>,
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/${encodeURIComponent(String(id))}/usages`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/items/{id}/usages`;

    const queryParams = {
      ['scope']: scope,      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ItemPreviewListV1>;
  }

  /**
   * @summary Get user-specific attributes of an item for the authenticated user.
   * @param {string} id - ID of the item to get attributes for
  */
  public getItemUserAttributes(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/${encodeURIComponent(String(id))}/userAttributes`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/items/{id}/userAttributes`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.ItemUserAttributesOutputV1>;
  }

  /**
   * @summary Get the datasources with items accessible to the current user
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results.
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results.
  */
  public getParentDatasources(
    {
      offset,
      limit
    } : {
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/parent-datasources`;
    const urlTemplate = `${baseUrl}/items/parent-datasources`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.DatasourcePairsOutputV1>;
  }

  /**
   * @summary Get all pinned items for an item, ordered by the most recent first
   * @param {string} [sourceId] - Id of the source item to get pinned items for. If not specified, the current user will be used.
  */
  public getPinnedItems(
    {
      sourceId
    } : {
      sourceId?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/pinned`;
    const urlTemplate = `${baseUrl}/items/pinned`;

    const queryParams = {
      ['sourceId']: sourceId
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ItemSearchPreviewListV1>;
  }

  /**
   * @summary Get a property
   * @param {string} id - ID of the item for which to retrieve the specified property
   * @param {string} propertyName - Name of the property to retrieve
  */
  public getProperty(
    {
      id,
      propertyName
    } : {
      id: string,
      propertyName: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }

    if (propertyName === null || propertyName === undefined) {
      throw new Error("'propertyName' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/${encodeURIComponent(String(id))}/properties/${encodeURIComponent(String(propertyName))}`
      .replace('{id}', encodeURIComponent(String(id)))
      .replace('{propertyName}', encodeURIComponent(String(propertyName)));
    const urlTemplate = `${baseUrl}/items/{id}/properties/{propertyName}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.PropertyOutputV1>;
  }

  /**
   * @summary Get stored table search failures for an item finder
   * @param {string} id - The Seeq ID for the item finder
  */
  public getStoredTableSearchFailures(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/finders/${encodeURIComponent(String(id))}/stored-table-search-failures`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/items/finders/{id}/stored-table-search-failures`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.StoredTableSearchFailureOutputListV1>;
  }

  /**
   * @summary For the Item to be swapped in, get a ranked list of potential swap-out Items from the paths of the Items whose IDs are passed as query parameters.  The ranking is based on the number of matches found among the descendants of the swap-in Item when the listed Item is chosen as the swap-out Item, where matching is established by comparing relative paths.
   * @param {string} id - ID of the root Item to be swapped in
   * @param {Array<string>} swapOutItemIds - IDs of the items to be swapped out
  */
  public getSwapOptions(
    {
      id,
      swapOutItemIds
    } : {
      id: string,
      swapOutItemIds: Array<string>
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }

    if (swapOutItemIds === null || swapOutItemIds === undefined) {
      throw new Error("'swapOutItemIds' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/${encodeURIComponent(String(id))}/swapOptions`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/items/{id}/swapOptions`;

    const queryParams = {
      ['swapOutItemIds']: swapOutItemIds
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.SwapOptionListV1>;
  }

  /**
   * @summary Lock an item and all items scoped to it.
   * @param {string} id - ID of the item to lock
  */
  public lockItem(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/${encodeURIComponent(String(id))}/lock`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/items/{id}/lock`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.LockedItemListOutputV1>;
  }

  /**
   * @summary Pin an item
   * @param {string} itemId - Id of the item to pin/mark as a favorite
   * @param {string} [sourceId] - Id of the source item. If not specified, the current user will be used.
  */
  public pinItem(
    {
      itemId,
      sourceId
    } : {
      itemId: string,
      sourceId?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (itemId === null || itemId === undefined) {
      throw new Error("'itemId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/pinned/${encodeURIComponent(String(itemId))}`
      .replace('{itemId}', encodeURIComponent(String(itemId)));
    const urlTemplate = `${baseUrl}/items/pinned/{itemId}`;

    const queryParams = {
      ['sourceId']: sourceId
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ItemSearchPreviewListV1>;
  }

  /**
   * @summary Remove an access control entry from an item
   * @param {string} id - ID of the item to remove access control entry from
   * @param {string} aceId - ID of the access control entry to remove
  */
  public removeAccessControlEntry(
    {
      id,
      aceId
    } : {
      id: string,
      aceId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }

    if (aceId === null || aceId === undefined) {
      throw new Error("'aceId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/${encodeURIComponent(String(id))}/ace/${encodeURIComponent(String(aceId))}`
      .replace('{id}', encodeURIComponent(String(id)))
      .replace('{aceId}', encodeURIComponent(String(aceId)));
    const urlTemplate = `${baseUrl}/items/{id}/ace/{aceId}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.AclOutputV1>;
  }

  /**
   * @summary Reset the Change Data Capture of an item.
   * @param {string} itemId - Id of the item to update.
  */
  public resetCdc(
    {
      itemId
    } : {
      itemId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (itemId === null || itemId === undefined) {
      throw new Error("'itemId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/${encodeURIComponent(String(itemId))}/resetCdc`
      .replace('{itemId}', encodeURIComponent(String(itemId)));
    const urlTemplate = `${baseUrl}/items/{itemId}/resetCdc`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.PropertyOutputV1>;
  }

  /**
   * @summary Get a collection of items
   * @param {Array<string>} [filters] - A list of item filters to reduce the result set. To logical AND multiple filters, use &lt;b&gt;\&quot;filter1 &amp;&amp; filter2&lt;/b&gt;\&quot; on a single line. To logical OR multiple filters, put each onto a new line. Filters can include any of the following options:&lt;br&gt;&lt;b&gt;Empty&lt;/b&gt;: returns the first ceiling number of items&lt;br&gt;&lt;b&gt;\&quot;value\&quot;&lt;/b&gt;: name or description of the item contains the case-insensitive value&lt;br&gt;&lt;b&gt;\&quot;field&#x3D;&#x3D;value\&quot;&lt;/b&gt;: specified field exactly matches the case-sensitive value or regex&lt;br&gt;&lt;b&gt;\&quot;field~&#x3D;value\&quot;&lt;/b&gt;: specified field contains the case-insensitive value or case-sensitive regex&lt;br&gt;To search for all items in the desired scope you may also use \&quot;\\*\&quot; character as filter.&lt;br&gt;&lt;b&gt;Example:&lt;/b&gt; Find items where (name or description contains case-insensitive \&quot;bulb\&quot; AND description contains case-insensitive \&quot;area a\&quot;) OR (items hosted by datasource \&quot;Example Data\&quot; where name exactly matches the regex \&quot;.\\*[ABC]_Temperature\&quot;)&lt;br&gt;&lt;b&gt;bulb &amp;&amp; Description~&#x3D;area a&lt;/b&gt;&lt;br&gt;&lt;b&gt;Datasource ID&#x3D;&#x3D;Example Data &amp;&amp; Name&#x3D;&#x3D;/.\\*[ABC]_Temperature/&lt;/b&gt;&lt;br&gt;To allow items with the &#x27;unsearchable&#x27; property to be returned, include &lt;b&gt;\&quot;@includeUnsearchable\&quot;&lt;/b&gt; on its own line&lt;br&gt;To exclude globally scoped items when using the \&quot;scope\&quot; filter include &lt;b&gt;\&quot;@excludeGloballyScoped\&quot;&lt;/b&gt; on its own line. own line. Use a type filter with only one item type for the best performance. Some combinations of item types are not allowed and must be split into separate searches.
   * @param {Array<string>} [scope] - IDs that limit the results to those which are in the global scope or are scoped to the items referenced by the IDs. &lt;br&gt;The following item types can act as a scope: &lt;b&gt;Workbook&lt;/b&gt;&lt;br&gt;If the scope is set to the Empty GUID then the scoped items are excluded
   * @param {string} [asset] - An ID that limits the results to items which are in the tree below the Asset referenced by the ID.
   * @param {Array<string>} [types] - A list of one or more case-sensitive item types which will restrict results to only those items that exactly match, or are children of, one of the specified types. If no types are provided then items of any type are returned
   * @param {Array<string>} [includeProperties] - A list of one or more case-sensitive item properties to include in every item this search finds. Use a single entry set to &lt;b&gt;\&quot;@allProperties\&quot;&lt;/b&gt; to specify that all item properties should be returned. Specified properties not present for an item are simply omitted and do not cause errors.
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results. When using limit or offset values to query different item subsets it is important to sort the results using orderBy. Otherwise inconsistent results may be returned.
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results. When using limit or offset values to query different item subsets it is important to sort the results using orderBy. Otherwise inconsistent results may be returned.
   * @param {Array<string>} [orderBy] - An optional list of one or more fields used to sort the results.
  */
  public searchItems(
    {
      filters,
      scope,
      asset,
      types,
      includeProperties,
      offset,
      limit,
      orderBy
    } : {
      filters?: Array<string>,
      scope?: Array<string>,
      asset?: string,
      types?: Array<string>,
      includeProperties?: Array<string>,
      offset?: number,
      limit?: number,
      orderBy?: SearchItemsOrderByEnum[]
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items`;
    const urlTemplate = `${baseUrl}/items`;

    const queryParams = {
      ['filters']: filters,      ['scope']: scope,      ['asset']: asset,      ['types']: types,      ['includeProperties']: includeProperties,      ['offset']: offset,      ['limit']: limit,      ['orderBy']: orderBy
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ItemSearchPreviewPaginatedListV1>;
  }

  /**
   * @summary Get a collection of items
  */
  public searchItemsPost(
    body: models.ItemSearchInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items`;
    const urlTemplate = `${baseUrl}/items`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ItemSearchPreviewPaginatedListV1>;
  }

  /**
   * @summary Set the access control list (list of access control entries) for an item.
   * @param {string} id - ID of the item to change access control list for
  */
  public setAcl(
    body: models.AclInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/${encodeURIComponent(String(id))}/acl`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/items/{id}/acl`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.AclOutputV1>;
  }

  /**
   * @summary Turns on or off access control inheritance for the specified item
   * @param {string} id - ID of the item to change access control inheritance for
   * @param {boolean} inheritAcl - True if the item should inherit access control from its parent, false if it shouldn&#x27;t.
  */
  public setAclInheritance(
    {
      id,
      inheritAcl
    } : {
      id: string,
      inheritAcl: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }

    if (inheritAcl === null || inheritAcl === undefined) {
      throw new Error("'inheritAcl' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/${encodeURIComponent(String(id))}/inheritacl/${encodeURIComponent(String(inheritAcl))}`
      .replace('{id}', encodeURIComponent(String(id)))
      .replace('{inheritAcl}', encodeURIComponent(String(inheritAcl)));
    const urlTemplate = `${baseUrl}/items/{id}/inheritacl/{inheritAcl}`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.AclOutputV1>;
  }

  /**
   * @summary Update the formula and formula parameters of an item
   * @param {string} id - ID of the item that is being updated
  */
  public setFormula(
    body: models.FormulaUpdateInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/${encodeURIComponent(String(id))}/formula`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/items/{id}/formula`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.CalculatedItemOutputV1>;
  }

  /**
   * @summary Set user-specific attributes of an item for the authenticated user.
   * @param {string} id - ID of the item to set user attributes for
  */
  public setItemUserAttributes(
    body: models.ItemUserAttributesInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/${encodeURIComponent(String(id))}/userAttributes`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/items/{id}/userAttributes`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ItemUserAttributesOutputV1>;
  }

  /**
   * @summary Set properties on the item identified by the supplied ID
   * @param {string} id - ID of the item to set properties on
  */
  public setProperties(
    body: Array<models.ScalarPropertyV1>,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/${encodeURIComponent(String(id))}/properties`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/items/{id}/properties`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ItemOutputV1>;
  }

  /**
   * @summary Set a property
   * @param {string} id - ID of the item to set the property on
   * @param {string} propertyName - Name of the property to set
  */
  public setProperty(
    body: models.PropertyInputV1,
    {
      id,
      propertyName
    } : {
      id: string,
      propertyName: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }

    if (propertyName === null || propertyName === undefined) {
      throw new Error("'propertyName' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/${encodeURIComponent(String(id))}/properties/${encodeURIComponent(String(propertyName))}`
      .replace('{id}', encodeURIComponent(String(id)))
      .replace('{propertyName}', encodeURIComponent(String(propertyName)));
    const urlTemplate = `${baseUrl}/items/{id}/properties/{propertyName}`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.PropertyHrefOutputV1>;
  }

  /**
   * @summary Update the scope of an item
   * @param {string} id - ID of the item that is having its scope updated
   * @param {string} [workbookId] - ID of the Workbook to which the item is being scoped. If not provided the item will be moved to the global scope
  */
  public setScope(
    {
      id,
      workbookId
    } : {
      id: string,
      workbookId?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/${encodeURIComponent(String(id))}/scope`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/items/{id}/scope`;

    const queryParams = {
      ['workbookId']: workbookId
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ItemOutputV1>;
  }

  /**
   * @summary Unpin an item
   * @param {string} itemId - Id of the item to unpin/unmark as a favorite
   * @param {string} [sourceId] - Id of the source item. If not specified, the current user will be used.
  */
  public unpinItem(
    {
      itemId,
      sourceId
    } : {
      itemId: string,
      sourceId?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (itemId === null || itemId === undefined) {
      throw new Error("'itemId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/pinned/${encodeURIComponent(String(itemId))}`
      .replace('{itemId}', encodeURIComponent(String(itemId)));
    const urlTemplate = `${baseUrl}/items/pinned/{itemId}`;

    const queryParams = {
      ['sourceId']: sourceId
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ItemSearchPreviewListV1>;
  }

  /**
   * @summary Update an item finder
   * @param {string} id - The Seeq ID for the item finder
  */
  public updateItemFinder(
    body: models.ItemFinderInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/finders/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/items/finders/{id}`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ItemFinderOutputV1>;
  }

  /**
   * @summary Validate whether the item in question is completely lockable.
   * @param {string} id - ID of the item to validate
  */
  public validateItemLockability(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/items/${encodeURIComponent(String(id))}/lock/validate`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/items/{id}/lock/validate`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.LockErrorsOutputV1>;
  }

}

export const SearchItemsOrderByEnum = {
    ID: 'ID',
    Name: 'Name',
    Description: 'Description'
} as const;

export type SearchItemsOrderByEnum = typeof SearchItemsOrderByEnum[keyof typeof SearchItemsOrderByEnum];

export const sqItemsApi = new sqItemsApiClass();

export type sqItemsApiEndpoints = {
  'addAccessControlEntry': {
    method: 'post';
    path: '/items/${encodeURIComponent(String(id))}/ace';
    response: models.AclOutputV1;
  };
  'archiveItem': {
    method: 'delete';
    path: '/items/${encodeURIComponent(String(id))}';
    response: models.StatusMessageBase;
  };
  'archiveItemFinder': {
    method: 'delete';
    path: '/items/finders/${encodeURIComponent(String(id))}';
    response: models.ArchiveOutputV1;
  };
  'buildStoredTableColumnDefinitions': {
    method: 'post';
    path: '/items/finders/stored-table-column-definitions';
    response: models.StoredTableColumnDefinitionsOutputV1;
  };
  'changeOwner': {
    method: 'post';
    path: '/items/${encodeURIComponent(String(itemId))}/owner/${encodeURIComponent(String(newOwnerId))}';
    response: models.StatusMessageBase;
  };
  'clearCache': {
    method: 'delete';
    path: '/items/${encodeURIComponent(String(id))}/cache';
    response: models.CacheInfoV1;
  };
  'countItemFinderSearches': {
    method: 'post';
    path: '/items/finders/search/count';
    response: models.ItemFinderSearchCountOutputV1;
  };
  'createContextCondition': {
    method: 'post';
    path: '/items/${encodeURIComponent(String(id))}/context';
    response: models.ConditionOutputV1;
  };
  'createItemFinder': {
    method: 'post';
    path: '/items/finders';
    response: models.ItemFinderOutputV1;
  };
  'deleteProperty': {
    method: 'delete';
    path: '/items/${encodeURIComponent(String(id))}/properties/${encodeURIComponent(String(propertyName))}';
    response: models.StatusMessageBase;
  };
  'executeItemFinder': {
    method: 'post';
    path: '/items/finders/${encodeURIComponent(String(id))}/run';
    response: models.ItemFinderOutputV1;
  };
  'executeItemFinderSearches': {
    method: 'post';
    path: '/items/finders/search';
    response: models.ItemFinderSearchesOutputV1;
  };
  'executeItemFinderSearchesV2': {
    method: 'post';
    path: '/items/finders/v2/search';
    response: models.ItemFinderSearchesOutputV2;
  };
  'findSwap': {
    method: 'post';
    path: '/items/${encodeURIComponent(String(id))}/swap';
    response: models.ItemPreviewV1;
  };
  'getAccessControl': {
    method: 'get';
    path: '/items/${encodeURIComponent(String(id))}/acl';
    response: models.AclOutputV1;
  };
  'getAccessControlDetails': {
    method: 'get';
    path: '/items/${encodeURIComponent(String(id))}/acl/details';
    response: models.AclOutputV1;
  };
  'getAssetChildrenByName': {
    method: 'get';
    path: '/items/asset-children-by-name';
    response: models.AssetChildrenByNamePaginatedListV1;
  };
  'getContextCondition': {
    method: 'get';
    path: '/items/${encodeURIComponent(String(id))}/context';
    response: models.ConditionOutputV1;
  };
  'getFormulaDependencies': {
    method: 'get';
    path: '/items/${encodeURIComponent(String(id))}/dependencies';
    response: models.ItemDependencyOutputV1;
  };
  'getFormulaDependents': {
    method: 'get';
    path: '/items/${encodeURIComponent(String(id))}/dependents';
    response: models.ItemPreviewListV1;
  };
  'getInterested': {
    method: 'get';
    path: '/items/${encodeURIComponent(String(id))}/interested';
    response: models.ItemPreviewListV1;
  };
  'getItemAndAllProperties': {
    method: 'get';
    path: '/items/${encodeURIComponent(String(id))}';
    response: models.ItemOutputV1;
  };
  'getItemFinder': {
    method: 'get';
    path: '/items/finders/${encodeURIComponent(String(id))}';
    response: models.ItemFinderOutputV1;
  };
  'getItemFinders': {
    method: 'get';
    path: '/items/finders';
    response: models.ItemFinderOutputListV1;
  };
  'getItemPreview': {
    method: 'get';
    path: '/items/${encodeURIComponent(String(id))}/preview';
    response: models.ItemSearchPreviewV1;
  };
  'getItemUsages': {
    method: 'get';
    path: '/items/${encodeURIComponent(String(id))}/usages';
    response: models.ItemPreviewListV1;
  };
  'getItemUserAttributes': {
    method: 'get';
    path: '/items/${encodeURIComponent(String(id))}/userAttributes';
    response: models.ItemUserAttributesOutputV1;
  };
  'getParentDatasources': {
    method: 'get';
    path: '/items/parent-datasources';
    response: models.DatasourcePairsOutputV1;
  };
  'getPinnedItems': {
    method: 'get';
    path: '/items/pinned';
    response: models.ItemSearchPreviewListV1;
  };
  'getProperty': {
    method: 'get';
    path: '/items/${encodeURIComponent(String(id))}/properties/${encodeURIComponent(String(propertyName))}';
    response: models.PropertyOutputV1;
  };
  'getStoredTableSearchFailures': {
    method: 'get';
    path: '/items/finders/${encodeURIComponent(String(id))}/stored-table-search-failures';
    response: models.StoredTableSearchFailureOutputListV1;
  };
  'getSwapOptions': {
    method: 'get';
    path: '/items/${encodeURIComponent(String(id))}/swapOptions';
    response: models.SwapOptionListV1;
  };
  'lockItem': {
    method: 'post';
    path: '/items/${encodeURIComponent(String(id))}/lock';
    response: models.LockedItemListOutputV1;
  };
  'pinItem': {
    method: 'post';
    path: '/items/pinned/${encodeURIComponent(String(itemId))}';
    response: models.ItemSearchPreviewListV1;
  };
  'removeAccessControlEntry': {
    method: 'delete';
    path: '/items/${encodeURIComponent(String(id))}/ace/${encodeURIComponent(String(aceId))}';
    response: models.AclOutputV1;
  };
  'resetCdc': {
    method: 'post';
    path: '/items/${encodeURIComponent(String(itemId))}/resetCdc';
    response: models.PropertyOutputV1;
  };
  'searchItems': {
    method: 'get';
    path: '/items';
    response: models.ItemSearchPreviewPaginatedListV1;
  };
  'searchItemsPost': {
    method: 'post';
    path: '/items';
    response: models.ItemSearchPreviewPaginatedListV1;
  };
  'setAcl': {
    method: 'post';
    path: '/items/${encodeURIComponent(String(id))}/acl';
    response: models.AclOutputV1;
  };
  'setAclInheritance': {
    method: 'post';
    path: '/items/${encodeURIComponent(String(id))}/inheritacl/${encodeURIComponent(String(inheritAcl))}';
    response: models.AclOutputV1;
  };
  'setFormula': {
    method: 'post';
    path: '/items/${encodeURIComponent(String(id))}/formula';
    response: models.CalculatedItemOutputV1;
  };
  'setItemUserAttributes': {
    method: 'post';
    path: '/items/${encodeURIComponent(String(id))}/userAttributes';
    response: models.ItemUserAttributesOutputV1;
  };
  'setProperties': {
    method: 'post';
    path: '/items/${encodeURIComponent(String(id))}/properties';
    response: models.ItemOutputV1;
  };
  'setProperty': {
    method: 'post';
    path: '/items/${encodeURIComponent(String(id))}/properties/${encodeURIComponent(String(propertyName))}';
    response: models.PropertyHrefOutputV1;
  };
  'setScope': {
    method: 'post';
    path: '/items/${encodeURIComponent(String(id))}/scope';
    response: models.ItemOutputV1;
  };
  'unpinItem': {
    method: 'delete';
    path: '/items/pinned/${encodeURIComponent(String(itemId))}';
    response: models.ItemSearchPreviewListV1;
  };
  'updateItemFinder': {
    method: 'post';
    path: '/items/finders/${encodeURIComponent(String(id))}';
    response: models.ItemFinderOutputV1;
  };
  'validateItemLockability': {
    method: 'get';
    path: '/items/${encodeURIComponent(String(id))}/lock/validate';
    response: models.LockErrorsOutputV1;
  };
};

type ApiAddAccessControlEntryResponse = models.AclOutputV1;
type ApiaddAccessControlEntryMutationParams = Parameters<typeof sqItemsApi.addAccessControlEntry> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqItemsApi.addAccessControlEntry>;

export function useApiAddAccessControlEntryMutation(
  options?: Omit<UseMutationOptions<ApiAddAccessControlEntryResponse, AxiosError<SeeqErrorData>,
    ApiaddAccessControlEntryMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiAddAccessControlEntryResponse, AxiosError<SeeqErrorData>,
  ApiaddAccessControlEntryMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApiaddAccessControlEntryMutationParams) =>
      sqItemsApi.addAccessControlEntry(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiArchiveItemResponse = models.StatusMessageBase;
type ApiarchiveItemMutationParams = Parameters<typeof sqItemsApi.archiveItem> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqItemsApi.archiveItem>;

export function useApiArchiveItemMutation(
  options?: Omit<UseMutationOptions<ApiArchiveItemResponse, AxiosError<SeeqErrorData>,
    ApiarchiveItemMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiArchiveItemResponse, AxiosError<SeeqErrorData>,
  ApiarchiveItemMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApiarchiveItemMutationParams) =>
      sqItemsApi.archiveItem(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiArchiveItemFinderResponse = models.ArchiveOutputV1;
type ApiarchiveItemFinderMutationParams = Parameters<typeof sqItemsApi.archiveItemFinder> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqItemsApi.archiveItemFinder>;

export function useApiArchiveItemFinderMutation(
  options?: Omit<UseMutationOptions<ApiArchiveItemFinderResponse, AxiosError<SeeqErrorData>,
    ApiarchiveItemFinderMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiArchiveItemFinderResponse, AxiosError<SeeqErrorData>,
  ApiarchiveItemFinderMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApiarchiveItemFinderMutationParams) =>
      sqItemsApi.archiveItemFinder(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiBuildStoredTableColumnDefinitionsResponse = models.StoredTableColumnDefinitionsOutputV1;
type ApibuildStoredTableColumnDefinitionsMutationParams = Parameters<typeof sqItemsApi.buildStoredTableColumnDefinitions> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqItemsApi.buildStoredTableColumnDefinitions>;
type ApibuildStoredTableColumnDefinitionsMutationVariables = models.StoredTableColumnDefinitionsInputV1;

export function useApiBuildStoredTableColumnDefinitionsMutation(
  options?: Omit<UseMutationOptions<ApiBuildStoredTableColumnDefinitionsResponse, AxiosError<SeeqErrorData>,
    ApibuildStoredTableColumnDefinitionsMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiBuildStoredTableColumnDefinitionsResponse, AxiosError<SeeqErrorData>,
  ApibuildStoredTableColumnDefinitionsMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApibuildStoredTableColumnDefinitionsMutationVariables) =>
      sqItemsApi.buildStoredTableColumnDefinitions(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiChangeOwnerResponse = models.StatusMessageBase;
type ApichangeOwnerMutationParams = Parameters<typeof sqItemsApi.changeOwner> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqItemsApi.changeOwner>;

export function useApiChangeOwnerMutation(
  options?: Omit<UseMutationOptions<ApiChangeOwnerResponse, AxiosError<SeeqErrorData>,
    ApichangeOwnerMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiChangeOwnerResponse, AxiosError<SeeqErrorData>,
  ApichangeOwnerMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApichangeOwnerMutationParams) =>
      sqItemsApi.changeOwner(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiClearCacheResponse = models.CacheInfoV1;
type ApiclearCacheMutationParams = Parameters<typeof sqItemsApi.clearCache> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqItemsApi.clearCache>;

export function useApiClearCacheMutation(
  options?: Omit<UseMutationOptions<ApiClearCacheResponse, AxiosError<SeeqErrorData>,
    ApiclearCacheMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiClearCacheResponse, AxiosError<SeeqErrorData>,
  ApiclearCacheMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApiclearCacheMutationParams) =>
      sqItemsApi.clearCache(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCountItemFinderSearchesResponse = models.ItemFinderSearchCountOutputV1;
/** Named request inputs; transport overrides do not identify cached data. */
type ApiCountItemFinderSearchesQueryParams = {
  body: models.ItemFinderSearchCountInputV1;
};

/** Omit inputs or individual fields to match multiple cached requests during invalidation. */
type ApiCountItemFinderSearchesQueryKeyParams = {
  [K in keyof ApiCountItemFinderSearchesQueryParams]?: Partial<ApiCountItemFinderSearchesQueryParams[K]>;
};

export function CountItemFinderSearchesQueryKey(input: ApiCountItemFinderSearchesQueryKeyParams) {
  return ['sqItemsApi', 'countItemFinderSearches', input] as const;
}

/** A safe, idempotent read transported as POST. The cache stores the unmodified SDK response payload. */
export function useApiCountItemFinderSearchesQuery<TData = ApiCountItemFinderSearchesResponse>(
  input: ApiCountItemFinderSearchesQueryParams,
  options?: Omit<UseQueryOptions<ApiCountItemFinderSearchesResponse, AxiosError<SeeqErrorData>, TData>, 'queryKey' | 'queryFn'> & {
    axiosInstance?: AxiosInstance;
    silent?: boolean;
  },
): UseQueryResult<TData, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: CountItemFinderSearchesQueryKey(input),
    queryFn: () => sqItemsApi.countItemFinderSearches(
      input.body,
      
      
      requestConfig,
    ).then((response) => response.data),
    ...queryOptions,
  });
}
type ApicountItemFinderSearchesMutationParams = Parameters<typeof sqItemsApi.countItemFinderSearches> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqItemsApi.countItemFinderSearches>;
type ApicountItemFinderSearchesMutationVariables = models.ItemFinderSearchCountInputV1;

export function useApiCountItemFinderSearchesMutation(
  options?: Omit<UseMutationOptions<ApiCountItemFinderSearchesResponse, AxiosError<SeeqErrorData>,
    ApicountItemFinderSearchesMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiCountItemFinderSearchesResponse, AxiosError<SeeqErrorData>,
  ApicountItemFinderSearchesMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApicountItemFinderSearchesMutationVariables) =>
      sqItemsApi.countItemFinderSearches(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiCreateContextConditionResponse = models.ConditionOutputV1;
type ApicreateContextConditionMutationParams = Parameters<typeof sqItemsApi.createContextCondition> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqItemsApi.createContextCondition>;

export function useApiCreateContextConditionMutation(
  options?: Omit<UseMutationOptions<ApiCreateContextConditionResponse, AxiosError<SeeqErrorData>,
    ApicreateContextConditionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiCreateContextConditionResponse, AxiosError<SeeqErrorData>,
  ApicreateContextConditionMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApicreateContextConditionMutationParams) =>
      sqItemsApi.createContextCondition(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateItemFinderResponse = models.ItemFinderOutputV1;
type ApicreateItemFinderMutationParams = Parameters<typeof sqItemsApi.createItemFinder> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqItemsApi.createItemFinder>;
type ApicreateItemFinderMutationVariables = models.ItemFinderInputV1;

export function useApiCreateItemFinderMutation(
  options?: Omit<UseMutationOptions<ApiCreateItemFinderResponse, AxiosError<SeeqErrorData>,
    ApicreateItemFinderMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiCreateItemFinderResponse, AxiosError<SeeqErrorData>,
  ApicreateItemFinderMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApicreateItemFinderMutationVariables) =>
      sqItemsApi.createItemFinder(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiDeletePropertyResponse = models.StatusMessageBase;
type ApideletePropertyMutationParams = Parameters<typeof sqItemsApi.deleteProperty> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqItemsApi.deleteProperty>;

export function useApiDeletePropertyMutation(
  options?: Omit<UseMutationOptions<ApiDeletePropertyResponse, AxiosError<SeeqErrorData>,
    ApideletePropertyMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiDeletePropertyResponse, AxiosError<SeeqErrorData>,
  ApideletePropertyMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApideletePropertyMutationParams) =>
      sqItemsApi.deleteProperty(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiExecuteItemFinderResponse = models.ItemFinderOutputV1;
type ApiexecuteItemFinderMutationParams = Parameters<typeof sqItemsApi.executeItemFinder> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqItemsApi.executeItemFinder>;

export function useApiExecuteItemFinderMutation(
  options?: Omit<UseMutationOptions<ApiExecuteItemFinderResponse, AxiosError<SeeqErrorData>,
    ApiexecuteItemFinderMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiExecuteItemFinderResponse, AxiosError<SeeqErrorData>,
  ApiexecuteItemFinderMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApiexecuteItemFinderMutationParams) =>
      sqItemsApi.executeItemFinder(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiExecuteItemFinderSearchesResponse = models.ItemFinderSearchesOutputV1;
type ApiexecuteItemFinderSearchesMutationParams = Parameters<typeof sqItemsApi.executeItemFinderSearches> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqItemsApi.executeItemFinderSearches>;
type ApiexecuteItemFinderSearchesMutationVariables = models.ItemFinderSearchesInputV1;

export function useApiExecuteItemFinderSearchesMutation(
  options?: Omit<UseMutationOptions<ApiExecuteItemFinderSearchesResponse, AxiosError<SeeqErrorData>,
    ApiexecuteItemFinderSearchesMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiExecuteItemFinderSearchesResponse, AxiosError<SeeqErrorData>,
  ApiexecuteItemFinderSearchesMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApiexecuteItemFinderSearchesMutationVariables) =>
      sqItemsApi.executeItemFinderSearches(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiExecuteItemFinderSearchesV2Response = models.ItemFinderSearchesOutputV2;
type ApiexecuteItemFinderSearchesV2MutationParams = Parameters<typeof sqItemsApi.executeItemFinderSearchesV2> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqItemsApi.executeItemFinderSearchesV2>;
type ApiexecuteItemFinderSearchesV2MutationVariables = models.ItemFinderSearchesInputV1;

export function useApiExecuteItemFinderSearchesV2Mutation(
  options?: Omit<UseMutationOptions<ApiExecuteItemFinderSearchesV2Response, AxiosError<SeeqErrorData>,
    ApiexecuteItemFinderSearchesV2MutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiExecuteItemFinderSearchesV2Response, AxiosError<SeeqErrorData>,
  ApiexecuteItemFinderSearchesV2MutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApiexecuteItemFinderSearchesV2MutationVariables) =>
      sqItemsApi.executeItemFinderSearchesV2(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiFindSwapResponse = models.ItemPreviewV1;
type ApifindSwapMutationParams = Parameters<typeof sqItemsApi.findSwap> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqItemsApi.findSwap>;

export function useApiFindSwapMutation(
  options?: Omit<UseMutationOptions<ApiFindSwapResponse, AxiosError<SeeqErrorData>,
    ApifindSwapMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiFindSwapResponse, AxiosError<SeeqErrorData>,
  ApifindSwapMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApifindSwapMutationParams) =>
      sqItemsApi.findSwap(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiGetAccessControlResponse = models.AclOutputV1;
export function GetAccessControlQueryKey(
  params: Parameters<typeof sqItemsApi.getAccessControl>[0],
) {
  return ['sqItemsApi', 'getAccessControl', params] as const;
}

export function useApiGetAccessControlQuery(
  params: Parameters<typeof sqItemsApi.getAccessControl>[0],
  options?: Omit<UseQueryOptions<ApiGetAccessControlResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetAccessControlResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetAccessControlQueryKey(params),
    queryFn: () =>
      sqItemsApi.getAccessControl(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetAccessControlDetailsResponse = models.AclOutputV1;
export function GetAccessControlDetailsQueryKey(
  params: Parameters<typeof sqItemsApi.getAccessControlDetails>[0],
) {
  return ['sqItemsApi', 'getAccessControlDetails', params] as const;
}

export function useApiGetAccessControlDetailsQuery(
  params: Parameters<typeof sqItemsApi.getAccessControlDetails>[0],
  options?: Omit<UseQueryOptions<ApiGetAccessControlDetailsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetAccessControlDetailsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetAccessControlDetailsQueryKey(params),
    queryFn: () =>
      sqItemsApi.getAccessControlDetails(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetAssetChildrenByNameResponse = models.AssetChildrenByNamePaginatedListV1;
export function GetAssetChildrenByNameQueryKey(
  params: Parameters<typeof sqItemsApi.getAssetChildrenByName>[0],
) {
  return ['sqItemsApi', 'getAssetChildrenByName', params] as const;
}

export function useApiGetAssetChildrenByNameQuery(
  params: Parameters<typeof sqItemsApi.getAssetChildrenByName>[0],
  options?: Omit<UseQueryOptions<ApiGetAssetChildrenByNameResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetAssetChildrenByNameResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetAssetChildrenByNameQueryKey(params),
    queryFn: () =>
      sqItemsApi.getAssetChildrenByName(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetContextConditionResponse = models.ConditionOutputV1;
export function GetContextConditionQueryKey(
  params: Parameters<typeof sqItemsApi.getContextCondition>[0],
) {
  return ['sqItemsApi', 'getContextCondition', params] as const;
}

export function useApiGetContextConditionQuery(
  params: Parameters<typeof sqItemsApi.getContextCondition>[0],
  options?: Omit<UseQueryOptions<ApiGetContextConditionResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetContextConditionResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetContextConditionQueryKey(params),
    queryFn: () =>
      sqItemsApi.getContextCondition(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetFormulaDependenciesResponse = models.ItemDependencyOutputV1;
export function GetFormulaDependenciesQueryKey(
  params: Parameters<typeof sqItemsApi.getFormulaDependencies>[0],
) {
  return ['sqItemsApi', 'getFormulaDependencies', params] as const;
}

export function useApiGetFormulaDependenciesQuery(
  params: Parameters<typeof sqItemsApi.getFormulaDependencies>[0],
  options?: Omit<UseQueryOptions<ApiGetFormulaDependenciesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetFormulaDependenciesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetFormulaDependenciesQueryKey(params),
    queryFn: () =>
      sqItemsApi.getFormulaDependencies(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetFormulaDependentsResponse = models.ItemPreviewListV1;
export function GetFormulaDependentsQueryKey(
  params: Parameters<typeof sqItemsApi.getFormulaDependents>[0],
) {
  return ['sqItemsApi', 'getFormulaDependents', params] as const;
}

export function useApiGetFormulaDependentsQuery(
  params: Parameters<typeof sqItemsApi.getFormulaDependents>[0],
  options?: Omit<UseQueryOptions<ApiGetFormulaDependentsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetFormulaDependentsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetFormulaDependentsQueryKey(params),
    queryFn: () =>
      sqItemsApi.getFormulaDependents(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetInterestedResponse = models.ItemPreviewListV1;
export function GetInterestedQueryKey(
  params: Parameters<typeof sqItemsApi.getInterested>[0],
) {
  return ['sqItemsApi', 'getInterested', params] as const;
}

export function useApiGetInterestedQuery(
  params: Parameters<typeof sqItemsApi.getInterested>[0],
  options?: Omit<UseQueryOptions<ApiGetInterestedResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetInterestedResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetInterestedQueryKey(params),
    queryFn: () =>
      sqItemsApi.getInterested(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetItemAndAllPropertiesResponse = models.ItemOutputV1;
export function GetItemAndAllPropertiesQueryKey(
  params: Parameters<typeof sqItemsApi.getItemAndAllProperties>[0],
) {
  return ['sqItemsApi', 'getItemAndAllProperties', params] as const;
}

export function useApiGetItemAndAllPropertiesQuery(
  params: Parameters<typeof sqItemsApi.getItemAndAllProperties>[0],
  options?: Omit<UseQueryOptions<ApiGetItemAndAllPropertiesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetItemAndAllPropertiesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetItemAndAllPropertiesQueryKey(params),
    queryFn: () =>
      sqItemsApi.getItemAndAllProperties(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetItemFinderResponse = models.ItemFinderOutputV1;
export function GetItemFinderQueryKey(
  params: Parameters<typeof sqItemsApi.getItemFinder>[0],
) {
  return ['sqItemsApi', 'getItemFinder', params] as const;
}

export function useApiGetItemFinderQuery(
  params: Parameters<typeof sqItemsApi.getItemFinder>[0],
  options?: Omit<UseQueryOptions<ApiGetItemFinderResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetItemFinderResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetItemFinderQueryKey(params),
    queryFn: () =>
      sqItemsApi.getItemFinder(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetItemFindersResponse = models.ItemFinderOutputListV1;
export function GetItemFindersQueryKey(
  params: Parameters<typeof sqItemsApi.getItemFinders>[0],
) {
  return ['sqItemsApi', 'getItemFinders', params] as const;
}

export function useApiGetItemFindersQuery(
  params: Parameters<typeof sqItemsApi.getItemFinders>[0],
  options?: Omit<UseQueryOptions<ApiGetItemFindersResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetItemFindersResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetItemFindersQueryKey(params),
    queryFn: () =>
      sqItemsApi.getItemFinders(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetItemPreviewResponse = models.ItemSearchPreviewV1;
export function GetItemPreviewQueryKey(
  params: Parameters<typeof sqItemsApi.getItemPreview>[0],
) {
  return ['sqItemsApi', 'getItemPreview', params] as const;
}

export function useApiGetItemPreviewQuery(
  params: Parameters<typeof sqItemsApi.getItemPreview>[0],
  options?: Omit<UseQueryOptions<ApiGetItemPreviewResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetItemPreviewResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetItemPreviewQueryKey(params),
    queryFn: () =>
      sqItemsApi.getItemPreview(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetItemUsagesResponse = models.ItemPreviewListV1;
export function GetItemUsagesQueryKey(
  params: Parameters<typeof sqItemsApi.getItemUsages>[0],
) {
  return ['sqItemsApi', 'getItemUsages', params] as const;
}

export function useApiGetItemUsagesQuery(
  params: Parameters<typeof sqItemsApi.getItemUsages>[0],
  options?: Omit<UseQueryOptions<ApiGetItemUsagesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetItemUsagesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetItemUsagesQueryKey(params),
    queryFn: () =>
      sqItemsApi.getItemUsages(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetItemUserAttributesResponse = models.ItemUserAttributesOutputV1;
export function GetItemUserAttributesQueryKey(
  params: Parameters<typeof sqItemsApi.getItemUserAttributes>[0],
) {
  return ['sqItemsApi', 'getItemUserAttributes', params] as const;
}

export function useApiGetItemUserAttributesQuery(
  params: Parameters<typeof sqItemsApi.getItemUserAttributes>[0],
  options?: Omit<UseQueryOptions<ApiGetItemUserAttributesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetItemUserAttributesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetItemUserAttributesQueryKey(params),
    queryFn: () =>
      sqItemsApi.getItemUserAttributes(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetParentDatasourcesResponse = models.DatasourcePairsOutputV1;
export function GetParentDatasourcesQueryKey(
  params: Parameters<typeof sqItemsApi.getParentDatasources>[0],
) {
  return ['sqItemsApi', 'getParentDatasources', params] as const;
}

export function useApiGetParentDatasourcesQuery(
  params: Parameters<typeof sqItemsApi.getParentDatasources>[0],
  options?: Omit<UseQueryOptions<ApiGetParentDatasourcesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetParentDatasourcesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetParentDatasourcesQueryKey(params),
    queryFn: () =>
      sqItemsApi.getParentDatasources(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetPinnedItemsResponse = models.ItemSearchPreviewListV1;
export function GetPinnedItemsQueryKey(
  params: Parameters<typeof sqItemsApi.getPinnedItems>[0],
) {
  return ['sqItemsApi', 'getPinnedItems', params] as const;
}

export function useApiGetPinnedItemsQuery(
  params: Parameters<typeof sqItemsApi.getPinnedItems>[0],
  options?: Omit<UseQueryOptions<ApiGetPinnedItemsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetPinnedItemsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetPinnedItemsQueryKey(params),
    queryFn: () =>
      sqItemsApi.getPinnedItems(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetPropertyResponse = models.PropertyOutputV1;
export function GetPropertyQueryKey(
  params: Parameters<typeof sqItemsApi.getProperty>[0],
) {
  return ['sqItemsApi', 'getProperty', params] as const;
}

export function useApiGetPropertyQuery(
  params: Parameters<typeof sqItemsApi.getProperty>[0],
  options?: Omit<UseQueryOptions<ApiGetPropertyResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetPropertyResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetPropertyQueryKey(params),
    queryFn: () =>
      sqItemsApi.getProperty(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetStoredTableSearchFailuresResponse = models.StoredTableSearchFailureOutputListV1;
export function GetStoredTableSearchFailuresQueryKey(
  params: Parameters<typeof sqItemsApi.getStoredTableSearchFailures>[0],
) {
  return ['sqItemsApi', 'getStoredTableSearchFailures', params] as const;
}

export function useApiGetStoredTableSearchFailuresQuery(
  params: Parameters<typeof sqItemsApi.getStoredTableSearchFailures>[0],
  options?: Omit<UseQueryOptions<ApiGetStoredTableSearchFailuresResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetStoredTableSearchFailuresResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetStoredTableSearchFailuresQueryKey(params),
    queryFn: () =>
      sqItemsApi.getStoredTableSearchFailures(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetSwapOptionsResponse = models.SwapOptionListV1;
export function GetSwapOptionsQueryKey(
  params: Parameters<typeof sqItemsApi.getSwapOptions>[0],
) {
  return ['sqItemsApi', 'getSwapOptions', params] as const;
}

export function useApiGetSwapOptionsQuery(
  params: Parameters<typeof sqItemsApi.getSwapOptions>[0],
  options?: Omit<UseQueryOptions<ApiGetSwapOptionsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetSwapOptionsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetSwapOptionsQueryKey(params),
    queryFn: () =>
      sqItemsApi.getSwapOptions(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiLockItemResponse = models.LockedItemListOutputV1;
type ApilockItemMutationParams = Parameters<typeof sqItemsApi.lockItem> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqItemsApi.lockItem>;

export function useApiLockItemMutation(
  options?: Omit<UseMutationOptions<ApiLockItemResponse, AxiosError<SeeqErrorData>,
    ApilockItemMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiLockItemResponse, AxiosError<SeeqErrorData>,
  ApilockItemMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApilockItemMutationParams) =>
      sqItemsApi.lockItem(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiPinItemResponse = models.ItemSearchPreviewListV1;
type ApipinItemMutationParams = Parameters<typeof sqItemsApi.pinItem> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqItemsApi.pinItem>;

export function useApiPinItemMutation(
  options?: Omit<UseMutationOptions<ApiPinItemResponse, AxiosError<SeeqErrorData>,
    ApipinItemMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiPinItemResponse, AxiosError<SeeqErrorData>,
  ApipinItemMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApipinItemMutationParams) =>
      sqItemsApi.pinItem(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiRemoveAccessControlEntryResponse = models.AclOutputV1;
type ApiremoveAccessControlEntryMutationParams = Parameters<typeof sqItemsApi.removeAccessControlEntry> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqItemsApi.removeAccessControlEntry>;

export function useApiRemoveAccessControlEntryMutation(
  options?: Omit<UseMutationOptions<ApiRemoveAccessControlEntryResponse, AxiosError<SeeqErrorData>,
    ApiremoveAccessControlEntryMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiRemoveAccessControlEntryResponse, AxiosError<SeeqErrorData>,
  ApiremoveAccessControlEntryMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApiremoveAccessControlEntryMutationParams) =>
      sqItemsApi.removeAccessControlEntry(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiResetCdcResponse = models.PropertyOutputV1;
type ApiresetCdcMutationParams = Parameters<typeof sqItemsApi.resetCdc> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqItemsApi.resetCdc>;

export function useApiResetCdcMutation(
  options?: Omit<UseMutationOptions<ApiResetCdcResponse, AxiosError<SeeqErrorData>,
    ApiresetCdcMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiResetCdcResponse, AxiosError<SeeqErrorData>,
  ApiresetCdcMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApiresetCdcMutationParams) =>
      sqItemsApi.resetCdc(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiSearchItemsResponse = models.ItemSearchPreviewPaginatedListV1;
export function SearchItemsQueryKey(
  params: Parameters<typeof sqItemsApi.searchItems>[0],
) {
  return ['sqItemsApi', 'searchItems', params] as const;
}

export function useApiSearchItemsQuery(
  params: Parameters<typeof sqItemsApi.searchItems>[0],
  options?: Omit<UseQueryOptions<ApiSearchItemsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiSearchItemsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: SearchItemsQueryKey(params),
    queryFn: () =>
      sqItemsApi.searchItems(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiSearchItemsPostResponse = models.ItemSearchPreviewPaginatedListV1;
type ApisearchItemsPostMutationParams = Parameters<typeof sqItemsApi.searchItemsPost> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqItemsApi.searchItemsPost>;
type ApisearchItemsPostMutationVariables = models.ItemSearchInputV1;

export function useApiSearchItemsPostMutation(
  options?: Omit<UseMutationOptions<ApiSearchItemsPostResponse, AxiosError<SeeqErrorData>,
    ApisearchItemsPostMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiSearchItemsPostResponse, AxiosError<SeeqErrorData>,
  ApisearchItemsPostMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApisearchItemsPostMutationVariables) =>
      sqItemsApi.searchItemsPost(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiSetAclResponse = models.AclOutputV1;
type ApisetAclMutationParams = Parameters<typeof sqItemsApi.setAcl> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqItemsApi.setAcl>;

export function useApiSetAclMutation(
  options?: Omit<UseMutationOptions<ApiSetAclResponse, AxiosError<SeeqErrorData>,
    ApisetAclMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiSetAclResponse, AxiosError<SeeqErrorData>,
  ApisetAclMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApisetAclMutationParams) =>
      sqItemsApi.setAcl(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiSetAclInheritanceResponse = models.AclOutputV1;
type ApisetAclInheritanceMutationParams = Parameters<typeof sqItemsApi.setAclInheritance> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqItemsApi.setAclInheritance>;

export function useApiSetAclInheritanceMutation(
  options?: Omit<UseMutationOptions<ApiSetAclInheritanceResponse, AxiosError<SeeqErrorData>,
    ApisetAclInheritanceMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiSetAclInheritanceResponse, AxiosError<SeeqErrorData>,
  ApisetAclInheritanceMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApisetAclInheritanceMutationParams) =>
      sqItemsApi.setAclInheritance(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiSetFormulaResponse = models.CalculatedItemOutputV1;
type ApisetFormulaMutationParams = Parameters<typeof sqItemsApi.setFormula> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqItemsApi.setFormula>;

export function useApiSetFormulaMutation(
  options?: Omit<UseMutationOptions<ApiSetFormulaResponse, AxiosError<SeeqErrorData>,
    ApisetFormulaMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiSetFormulaResponse, AxiosError<SeeqErrorData>,
  ApisetFormulaMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApisetFormulaMutationParams) =>
      sqItemsApi.setFormula(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiSetItemUserAttributesResponse = models.ItemUserAttributesOutputV1;
type ApisetItemUserAttributesMutationParams = Parameters<typeof sqItemsApi.setItemUserAttributes> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqItemsApi.setItemUserAttributes>;

export function useApiSetItemUserAttributesMutation(
  options?: Omit<UseMutationOptions<ApiSetItemUserAttributesResponse, AxiosError<SeeqErrorData>,
    ApisetItemUserAttributesMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiSetItemUserAttributesResponse, AxiosError<SeeqErrorData>,
  ApisetItemUserAttributesMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApisetItemUserAttributesMutationParams) =>
      sqItemsApi.setItemUserAttributes(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiSetPropertiesResponse = models.ItemOutputV1;
type ApisetPropertiesMutationParams = Parameters<typeof sqItemsApi.setProperties> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqItemsApi.setProperties>;

export function useApiSetPropertiesMutation(
  options?: Omit<UseMutationOptions<ApiSetPropertiesResponse, AxiosError<SeeqErrorData>,
    ApisetPropertiesMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiSetPropertiesResponse, AxiosError<SeeqErrorData>,
  ApisetPropertiesMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApisetPropertiesMutationParams) =>
      sqItemsApi.setProperties(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiSetPropertyResponse = models.PropertyHrefOutputV1;
type ApisetPropertyMutationParams = Parameters<typeof sqItemsApi.setProperty> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqItemsApi.setProperty>;

export function useApiSetPropertyMutation(
  options?: Omit<UseMutationOptions<ApiSetPropertyResponse, AxiosError<SeeqErrorData>,
    ApisetPropertyMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiSetPropertyResponse, AxiosError<SeeqErrorData>,
  ApisetPropertyMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApisetPropertyMutationParams) =>
      sqItemsApi.setProperty(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiSetScopeResponse = models.ItemOutputV1;
type ApisetScopeMutationParams = Parameters<typeof sqItemsApi.setScope> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqItemsApi.setScope>;

export function useApiSetScopeMutation(
  options?: Omit<UseMutationOptions<ApiSetScopeResponse, AxiosError<SeeqErrorData>,
    ApisetScopeMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiSetScopeResponse, AxiosError<SeeqErrorData>,
  ApisetScopeMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApisetScopeMutationParams) =>
      sqItemsApi.setScope(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUnpinItemResponse = models.ItemSearchPreviewListV1;
type ApiunpinItemMutationParams = Parameters<typeof sqItemsApi.unpinItem> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqItemsApi.unpinItem>;

export function useApiUnpinItemMutation(
  options?: Omit<UseMutationOptions<ApiUnpinItemResponse, AxiosError<SeeqErrorData>,
    ApiunpinItemMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiUnpinItemResponse, AxiosError<SeeqErrorData>,
  ApiunpinItemMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApiunpinItemMutationParams) =>
      sqItemsApi.unpinItem(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUpdateItemFinderResponse = models.ItemFinderOutputV1;
type ApiupdateItemFinderMutationParams = Parameters<typeof sqItemsApi.updateItemFinder> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqItemsApi.updateItemFinder>;

export function useApiUpdateItemFinderMutation(
  options?: Omit<UseMutationOptions<ApiUpdateItemFinderResponse, AxiosError<SeeqErrorData>,
    ApiupdateItemFinderMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiUpdateItemFinderResponse, AxiosError<SeeqErrorData>,
  ApiupdateItemFinderMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApiupdateItemFinderMutationParams) =>
      sqItemsApi.updateItemFinder(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiValidateItemLockabilityResponse = models.LockErrorsOutputV1;
export function ValidateItemLockabilityQueryKey(
  params: Parameters<typeof sqItemsApi.validateItemLockability>[0],
) {
  return ['sqItemsApi', 'validateItemLockability', params] as const;
}

export function useApiValidateItemLockabilityQuery(
  params: Parameters<typeof sqItemsApi.validateItemLockability>[0],
  options?: Omit<UseQueryOptions<ApiValidateItemLockabilityResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiValidateItemLockabilityResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: ValidateItemLockabilityQueryKey(params),
    queryFn: () =>
      sqItemsApi.validateItemLockability(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
